// extracted by mini-css-extract-plugin
module.exports = {"spinner":"loading_spinner__Kfo5a","spinner2":"loading_spinner2__2tfIP"};